import * as React from 'react';
import PropTypes from 'prop-types';

import { sortSizes } from '../utilities';

function ProductFilters({
  products,
  setSizeFilter,
  setItemsToShow,
  setStyleFilter,
  setBrandFilter,
}) {
  // Manage options for 'Filter by x' select menus in state
  const [productSizes, setProductSizes] = React.useState([]);
  const [productTypes, setProductTypes] = React.useState([]);
  const [productBrands, setProductBrands] = React.useState([]);

  React.useEffect(() => {
    // Function to find all the unique product sizes
    const uniqueProductSizes = [];

    products.forEach((product) => {
      for (let i = 0; i < product.options.length; i += 1) {
        if (product.options[i].name === 'Size') {
          for (let j = 0; j < product.options[i].values.length; j += 1) {
            if (!uniqueProductSizes.includes(product.options[i].values[j])) {
              uniqueProductSizes.push(product.options[i].values[j]);
            }
          }
        }
      }
    });

    const sortedSizes = sortSizes(uniqueProductSizes);

    // sortedSizes now contains an array of only the above possibilities.
    // Then we take the rest of the size options here...
    let tempSizes = uniqueProductSizes.filter(
      (size) => !sortedSizes.includes(size)
    );

    // ...and sort them alphabetically
    tempSizes = tempSizes.sort((a, b) => a.localeCompare(b));

    // Finally we append them to the original sorted array
    const sizeOptions = [].concat(sortedSizes, tempSizes);

    setProductSizes(sizeOptions);

    // Function to find all the unique productType values in array
    const uniqueTypes = (arr) => [
      ...new Set(
        arr.filter((a) => a.productType !== '').map((a) => a.productType)
      ),
    ];

    // Set only unique productTypes in state
    const uniqueProductTypes = uniqueTypes(products);
    setProductTypes(uniqueProductTypes);

    // Function to find all the unique product brand values in array
    const uniqueBrands = (arr) => [
      ...new Set(arr.filter((a) => a.vendor !== '').map((a) => a.vendor)),
    ];

    // Set only unique productTypes in state
    const uniqueProductBrands = uniqueBrands(products);
    setProductBrands(uniqueProductBrands);
  }, [products]);

  function handleProductFilter(e) {
    setItemsToShow(8);
    setSizeFilter(e.target.value);
  }

  function handleStyleFilter(e) {
    setItemsToShow(8);
    setStyleFilter(e.target.value);
  }

  function handleBrandFilter(e) {
    setItemsToShow(8);
    setBrandFilter(e.target.value);
  }

  return (
    <div className="flex w-full px-4 mx-auto mt-6 sm:px-6 md:px-8 max-w-7xl">
      <div className="flex flex-wrap items-center justify-between w-full sm:justify-start sm:space-x-12">
        {productSizes.length > 1 && (
          <div className="w-full mt-6 sm:w-auto">
            <label
              htmlFor="filter_by_product_size"
              className="sm:flex sm:items-center sm:justify-start"
            >
              <h3 className="text-xs tracking-wider uppercase">
                Filter by size
              </h3>
              <select
                onChange={handleProductFilter}
                name="filter_by_product_size"
                id="filter_by_product_size"
                className="w-full rounded-none form-select focus:border-primary-light focus:shadow-outline-primary sm:ml-4 sm:w-auto"
              >
                <option key="All" value="All">
                  All Sizes
                </option>
                {productSizes.map((productSize) => (
                  <option key={productSize} value={productSize}>
                    {productSize}
                  </option>
                ))}
              </select>
            </label>
          </div>
        )}
        {productTypes.length > 1 && (
          <div className="w-full mt-6 sm:w-auto">
            <label
              htmlFor="filter_by_product_style"
              className="sm:flex sm:items-center sm:justify-start"
            >
              <h3 className="text-xs tracking-wider uppercase">
                Filter by style
              </h3>
              <select
                onChange={handleStyleFilter}
                name="filter_by_product_style"
                id="filter_by_product_style"
                className="w-full rounded-none form-select focus:border-primary-light focus:shadow-outline-primary sm:ml-4 sm:w-auto"
              >
                <option key="All" value="All">
                  All Styles
                </option>
                {productTypes
                  .sort((a, b) => a.localeCompare(b))
                  .map((productType) => (
                    <option key={productType} value={productType}>
                      {productType}
                    </option>
                  ))}
              </select>
            </label>
          </div>
        )}
        {productBrands.length > 1 && (
          <div className="w-full mt-6 sm:w-auto">
            <label
              htmlFor="filter_by_product_brand"
              className="sm:flex sm:items-center sm:justify-start"
            >
              <h3 className="text-xs tracking-wider uppercase">
                Filter by brand
              </h3>
              <select
                onChange={handleBrandFilter}
                name="filter_by_product_brand"
                id="filter_by_product_brand"
                className="w-full rounded-none form-select focus:border-primary-light focus:shadow-outline-primary sm:ml-4 sm:w-auto"
              >
                <option key="All" value="All">
                  All Brands
                </option>
                {productBrands
                  .sort((a, b) => a.localeCompare(b))
                  .map((productBrand) => (
                    <option key={productBrand} value={productBrand}>
                      {productBrand}
                    </option>
                  ))}
              </select>
            </label>
          </div>
        )}
      </div>
    </div>
  );
}

ProductFilters.propTypes = {
  products: PropTypes.array,
  setSizeFilter: PropTypes.func,
  setItemsToShow: PropTypes.func,
  setStyleFilter: PropTypes.func,
  setBrandFilter: PropTypes.func,
};

export { ProductFilters };
